import { useState } from 'react';

// Custom hook to add callback functionality to useState
const useStateWithCallback = (initialState, callback) => {
  const [state, setState] = useState(initialState);

  const setStateWithCallback = (newState) => {
    setState(newState);
    if (typeof callback === 'function') {
      callback(newState);
    }
  };

  return [state, setStateWithCallback];
};

export default useStateWithCallback;